<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row class="no-search">
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i
          class="el-icon-zoom-in"
          v-else
          @click="$root.showPopUp(displayTitle, option)"
        ></i>
      </el-row>
      <hr />
      <el-row>
        <!-- <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          style="height: 44vh !important; min-height: 320px"
        /> -->
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
        />
      </el-row>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "CancelDailPercentChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      endDate: this.$root.endDate,
      option: this.option,
      loading: this.loading,
    };
  },

  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.bashMonthChange();
    });
  },
  created() {
    let self = this;
    self.loading = true;
    api.getCancelDailPercent(this.endDate).then(
      (res) => {
        let data = res.data;
        let year_list = data.year_list;
        let data_list = data.output_list;
        self.option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            top: 20,
            data: year_list,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: data.month_list,
          },
          yAxis: {
            type: "value",
            name: "%",
            min: 0,
            max: 5,
            interval: 1,
            axisLabel: {
              formatter: "{value}",
            },
          },
          series: data_list,
        };
        self.loading = false;
      },
      (err) => {
        console.log(err);
      }
    );
  },

  methods: {
    bashMonthChange() {
      let self = this;
      self.loading = true;

      api.getCancelDailPercent(this.endDate).then(
        (res) => {
          let data = res.data;
          let year_list = data.year_list;
          let data_list = data.output_list;
          self.option = {
            tooltip: {
              trigger: "axis",
            },
            legend: {
              top: 20,
              data: year_list,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: data.month_list,
            },
            yAxis: {
              type: "value",
              name: "%",
              min: 0,
              max: 5,
              interval: 1,
              axisLabel: {
                formatter: "{value}",
              },
            },
            series: data_list,
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
</style>
